export function current() {
  const path = location.pathname;
  if(path.match('concept'))
  {
    $('.j-current_concept').addClass('current');
  }
  else if(path.match('introduction'))
  {
    $('.j-current_introduction').addClass('current');
  }
  else if(path.match('news'))
  {
    $('.j-current_news').addClass('current');
  }
  else if(path.match('company'))
  {
    $('.j-current_company').addClass('current');
  }
}
